import DatePicker from 'react-datepicker';
import RequiredSign from '../global-components/required-sign';
import {
  ErrorText,
  FieldLabel,
} from '../'
import './DateField.scss';

interface Props {
  label: string;
  value: Date | null;
  minDate?: Date | null;
  isInError: boolean;
  errorText: string;
  required?: boolean;
  onChange: (newValue: Date | null) => void;
}

export default function DateField({
  label,
  value,
  minDate,
  isInError,
  errorText,
  required,
  onChange,
}: Props) {
  return (
    <div className='DateField'>
      <div className='LabelContainer'>
        <FieldLabel
          text={label}
        />
        {required && <RequiredSign />}
      </div>
      <DatePicker
        className='DatePicker'
        placeholderText='yyyy-MM-dd'
        dateFormat='yyyy-MM-dd'
        selected={value}
        onChange={onChange}
        minDate={minDate}
        calendarIconClassname='calendarIcon'
        showIcon
      />
      <ErrorText
        text={errorText}
        isActive={isInError}
      />
    </div>
  );
}
